import { Scissors, Truck, Check } from 'lucide-react';
import { LANDING } from '@/constants/testIds';
import { SERVICES } from '@/data/business';
import { useReveal } from '@/hooks/useReveal';

const ICONS = { 'S/01': Scissors, 'S/02': Truck };

const SERVICE_IMAGES = {
    'S/01': 'https://static.prod-images.emergentagent.com/jobs/93b2539c-8b99-40f4-b1a4-8f040292204c/images/d9f6664053f416691b4680efb11088c6914065ae8cb55da056706450a67ac696.png',
    'S/02': 'https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=1600&q=80',
};

export const Services = () => {
    const [ref, visible] = useReveal();

    return (
        <section
            id="services"
            data-testid={LANDING.services}
            ref={ref}
            className="relative py-20 sm:py-28 border-t border-white/5"
        >
            <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
                <div className={`reveal ${visible ? 'in-view' : ''} flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-10 sm:mb-14`}>
                    <div>
                        <span className="section-label">05 / Services associés</span>
                        <h2 className="mt-4 font-display uppercase text-4xl sm:text-6xl lg:text-7xl leading-[0.9] text-white">
                            <span className="text-outline-yellow">Au-delà</span>
                            <br />du vêtement
                        </h2>
                    </div>
                    <p className="max-w-md text-base sm:text-lg text-white leading-relaxed">
                        Atelier de personnalisation intégré et livraison en Île-de-France. On s'occupe de tout — du logo brodé à la palette livrée sur chantier.
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                    {SERVICES.map((srv, i) => {
                        const Icon = ICONS[srv.code] || Scissors;
                        return (
                            <article
                                key={srv.code}
                                className={`group relative corner-cut overflow-hidden bg-[#0F0F0F] border border-white/10 hover:border-[#FFD500]/50 transition-all duration-500 ${
                                    visible ? 'in-view reveal' : 'reveal'
                                }`}
                                style={{ animationDelay: `${0.15 + i * 0.1}s` }}
                            >
                                <div className="grid sm:grid-cols-[1.1fr,1fr]">
                                    <div className="relative h-56 sm:h-auto sm:min-h-[340px] overflow-hidden">
                                        <img
                                            src={SERVICE_IMAGES[srv.code]}
                                            alt={srv.title}
                                            className="absolute inset-0 h-full w-full object-cover opacity-70 group-hover:scale-105 group-hover:opacity-90 transition-all duration-700"
                                            loading="lazy"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/70 via-transparent to-transparent" />
                                        <div className="absolute top-4 left-4 inline-flex items-center gap-2 glass px-3 py-1.5 rounded-sm">
                                            <Icon className="h-3.5 w-3.5 text-[#FFD500]" />
                                            <span className="text-[10px] uppercase tracking-[0.22em] text-white/80 font-bold">
                                                {srv.code}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="p-6 sm:p-8 flex flex-col justify-between gap-6">
                                        <div>
                                            <h3 className="font-display uppercase text-3xl sm:text-4xl text-white leading-none">
                                                {srv.title}
                                            </h3>
                                            <p className="mt-4 text-sm text-white/65 leading-relaxed">
                                                {srv.description}
                                            </p>
                                        </div>

                                        <ul className="space-y-2">
                                            {srv.bullets.map((b) => (
                                                <li key={b} className="flex items-center gap-2 text-sm text-white/80">
                                                    <span className="inline-flex h-5 w-5 items-center justify-center bg-[#FFD500] text-black">
                                                        <Check className="h-3 w-3" strokeWidth={3} />
                                                    </span>
                                                    {b}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
